import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--nav-bar"
export default class extends Controller {
  static targets = ["navBarContainer", "navBarActive"];

  connect() {
    this.moveNavBarPosition();
  }

  moveNavBarPosition() {
    const container = this.navBarContainerTarget;
    const activeButton = this.navBarActiveTarget.querySelector("button");

    const containerRect = container.getBoundingClientRect();
    const buttonRect = activeButton.getBoundingClientRect();

    // 左にずらす量を計算
    const offsetLeft =
      buttonRect.left -
      containerRect.left + // ボタンの左端 - コンテナの左端
      buttonRect.width / 2 - // → ボタンの中心
      container.clientWidth / 2;

    // スクロールアニメーション（スムーズスクロール）
    container.scrollTo({
      left: offsetLeft,
      behavior: "smooth",
    });
  }
}
